import React from "react"
import Layout from "../components/layoutSubMenu"
import Seo from "../components/seo"
import { graphql } from "gatsby"
import Menu from "../components/menu"
import BlogHero from "../components/blog-hero"

const BlogDetail = ({ data, pageContext }) => (
  <Layout>
    <Menu />
    <Seo title={data.contentfulBlogPost.title} />
    <section
      className="reise-beschreibung-background"
      style={{ marginTop: "3rem" }}
    >
      <div className="reise-beschreibung-container">
        <div className="reise-beschreibung reise-beschreibung-blog">
          <div className="float-left">
            <BlogHero
              title={data.contentfulBlogPost.title}
              img={data.contentfulBlogPost.heroImage.gatsbyImageData}
            />
          </div>

          <div
            className="reise-beschreibung-text"
            style={{ paddingTop: "1.45rem" }}
            dangerouslySetInnerHTML={{
              __html: data.contentfulBlogPost.body.childMarkdownRemark.html,
            }}
          ></div>
        </div>
      </div>
    </section>
  </Layout>
)

export const query = graphql`
  query ($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      heroImage {
        gatsbyImageData(width: 735, layout: CONSTRAINED)
      }
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`

export default BlogDetail
